<!-- <h1>Login Logout Page</h1> -->
<!-- <div>
<h1 class="page-header">Create View - {{ logData.model }}</h1>
</div> -->

<div class="table-responsive">
  <table class="table table-bordered mb-0">
    <thead>
      <tr>
        <th>Field</th>
        <th>Value</th>
      </tr>
    </thead>
    <tbody>
      @for (key of (viewLogsData | keyvalue); track key) {
        <tr>
          <td class="key-column">
            {{ key.key | transformKey }}
            @if (isArray(key.value)) {
              <span class="badge bg-primary">
                {{ key.value.length || 0 }} Items
              </span>
            }
          </td>
          <td>
            <!-- Primitive -->
            @if (!isObject(key.value) && !isArray(key.value)) {
              <span>
                @if(isCheckTimeZoneCheck(key.key)) {
                  {{ asAny(key.value) | timezone:'startEndTime' }}
                  }@else{
                  {{ asAny(key.value) | timezone: 'minutes' }}
                }
              </span>
            }
            <!-- Array -->
            @if (isArray(key.value)) {
              <ul>
                @for (item of key.value; track item) {
                  <li>
                    @if (!isObject(item)) {
                      <span>{{ item }}</span>
                    }
                    @if (isObject(item)) {
                      <button class="btn btn-link p-0"
                        (click)="openPopupFromKey(item['teacher_username'] || 'Details', item, popupTemplate)">
                        {{ item['teacher_username'] || 'View Details' }}
                      </button>
                    }
                  </li>
                }
              </ul>
            }
            <!-- Object: show as table if only 1 or 2 levels deep -->
            @if (isObject(key.value) && !isArray(key.value)) {
              <table class="table table-bordered mb-0 table-sm mb-0">
                <tbody>
                  @for (nested of (key.value | keyvalue); track nested) {
                    <tr>
                      <td
                        [ngStyle]="nested.key === 'new_value' ? {'background-color': '#DEFFEF'} : (nested.key === 'old_value' ? {'background-color': '#FFCFCF'} : {})">
                      {{ nested.key | transformKey }}</td>
                      <td
                        [ngStyle]="nested.key === 'new_value' ? {'background-color': '#DEFFEF'} : (nested.key === 'old_value' ? {'background-color': '#FFCFCF'} : {})">
                        @if (!isObject(nested.value) && !isArray(nested.value)) {
                          <span>
                            {{ nested.value || 'N/A' }}
                          </span>
                        }
                        <!-- 2nd level: show as table -->
                        @if (isObject(nested.value) && !isArray(nested.value)) {
                          <table class="table table-bordered mb-0 table-sm mb-0">
                            <tbody>
                              @for (deep of (nested.value | keyvalue); track deep) {
                                <tr>
                                  <td
                                    [ngStyle]="nested.key === 'new_value' ? {'background-color': '#DEFFEF'} : (nested.key === 'old_value' ? {'background-color': '#FFCFCF'} : {})">
                                  {{ deep.key | transformKey }}</td>
                                  <td
                                    [ngStyle]="nested.key === 'new_value' ? {'background-color': '#DEFFEF'} : (nested.key === 'old_value' ? {'background-color': '#FFCFCF'} : {})">
                                    @if (!isObject(deep.value) && !isArray(deep.value)) {
                                      <span>
                                        {{ deep.value | timezone }}
                                      </span>
                                    }
                                    <!-- 3rd level: show as table, 4th+ as popup -->
                                    @if (isObject(deep.value) && !isArray(deep.value)) {
                                      <table class="table table-bordered mb-0 table-sm mb-0">
                                        <tbody>
                                          @for (extra of (deep.value | keyvalue); track extra) {
                                            <tr>
                                              <td>{{ extra.key | transformKey }}</td>
                                              <td>
                                                @if (!isObject(extra.value) && !isArray(extra.value)) {
                                                  <span>
                                                    {{ extra.value | timezone }}
                                                  </span>
                                                }
                                                <!-- 4th+ level: show as popup -->
                                                @if (isObject(extra.value) || isArray(extra.value)) {
                                                  <button
                                                    class="btn btn-link p-0"
                                                    (click)="openPopupFromKey(extra.key, extra.value, popupTemplate)">
                                                    View Nested Details
                                                  </button>
                                                }
                                              </td>
                                            </tr>
                                          }
                                        </tbody>
                                      </table>
                                    }
                                    @if (isArray(deep.value)) {
                                      <ul>
                                        @for (extra of deep.value; track extra) {
                                          <li>
                                            @if (!isObject(extra)) {
                                              <span>{{ extra }}</span>
                                            }
                                            @if (isObject(extra)) {
                                              <table class="table table-bordered mb-0 table-sm mb-0">
                                                <tbody>
                                                  @for (extraDeep of (extra | keyvalue); track extraDeep) {
                                                    <tr>
                                                      <td>{{ extraDeep.key | transformKey }}</td>
                                                      <td>
                                                        @if (!isObject(extraDeep.value) && !isArray(extraDeep.value)) {
                                                          <span>
                                                            {{ extraDeep.value | timezone }}
                                                          </span>
                                                        }
                                                        <!-- 4th+ level: show as popup -->
                                                        @if (isObject(extraDeep.value) || isArray(extraDeep.value)) {
                                                          <button
                                                            class="btn btn-link p-0"
                                                            (click)="openPopupFromKey(extraDeep.key, extraDeep.value, popupTemplate)">
                                                            View Nested Details
                                                          </button>
                                                        }
                                                      </td>
                                                    </tr>
                                                  }
                                                </tbody>
                                              </table>
                                            }
                                          </li>
                                        }
                                      </ul>
                                    }
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        }
                        <!-- 2nd level: array -->
                        @if (isArray(nested.value)) {
                          <ul>
                            @for (item of nested.value; track item) {
                              <li>
                                @if (!isObject(item)) {
                                  <span>{{ item }}</span>
                                }
                                @if (isObject(item)) {
                                  <table class="table table-bordered mb-0 table-sm mb-0">
                                    <tbody>
                                      @for (deep of (item | keyvalue); track deep) {
                                        <tr>
                                          <td>{{ deep.key | transformKey }}</td>
                                          <td>
                                            @if (!isObject(deep.value) && !isArray(deep.value)) {
                                              <span>
                                                {{ deep.value || 'N/A' }}
                                              </span>
                                            }
                                            <!-- 3rd level: show as popup -->
                                            @if (isObject(deep.value) || isArray(deep.value)) {
                                              <button class="btn btn-link p-0"
                                                (click)="openPopupFromKey(deep.key, deep.value, popupTemplate)">
                                                View Nested Details
                                              </button>
                                            }
                                          </td>
                                        </tr>
                                      }
                                    </tbody>
                                  </table>
                                }
                              </li>
                            }
                          </ul>
                        }
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<!-- Popup Modal -->
<ng-template #popupTemplate let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ popupTitle | transformKey }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss(); closePopup()"></button>
  </div>
  <div class="modal-body">
    <table class="table table-bordered mb-0">
      <thead>
        <tr>
          <th>Field</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        @for (infoKey of (popupData | keyvalue); track infoKey) {
          <tr>
            <td class="key-column">{{ infoKey.key | transformKey }}</td>
            <td>
              <!-- Primitive -->
              @if (!isObject(infoKey.value) && !isArray(infoKey.value)) {
                <span>
                  @if(isCheckTimeZoneCheck(infoKey.key)) {
                    {{ asAny(infoKey.value) | timezone:'startEndTime' }}
                    }@else{
                    {{ asAny(infoKey.value) | timezone }}
                  }
                </span>
              }
              <!-- Object -->
              @if (isObject(infoKey.value)) {
                <button class="btn btn-link p-0"
                  (click)="openPopupFromKey(infoKey.key, infoKey.value, popupTemplate)">
                  View Nested Details
                </button>
              }
              <!-- Array inside object -->
              @if (isArray(infoKey.value)) {
                <ul>
                  @for (item of infoKey.value; track item) {
                    <li>
                      @if (!isObject(item)) {
                        <span>{{ item }}</span>
                      }
                      @if (isObject(item)) {
                        <button class="btn btn-link p-0"
                          (click)="openPopupFromKey(item['teacher_username'] || 'Details', item, popupTemplate)">
                          {{ item['teacher_username'] || 'View Details' }}
                        </button>
                      }
                    </li>
                  }
                </ul>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close(); closePopup()">
      Close
    </button>
  </div>
</ng-template>